const actions = {
  SET_STATE: 'region-names/SET_STATE',
}

export default actions
